import React from 'react'
import NotMatch from '../pages_renew/NoMatch'

class ErrorBoundary extends React.PureComponent {
  state = {
    hasError: false
  }

  static getDerivedStateFromError () {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      // return <h1>Something went wrong.</h1>
      return <NotMatch
        title={'🙁页面不存在'}
        message={'Something went wrong.'}
      />
    }

    return this.props.children
  }
}

export default ErrorBoundary